export const SET_SESSION = 'setSession'
export const SET_ERRORS = 'setErrors'
export const RESET_STATE = 'resetState'
export const SET_AUTH_MANUALLY = 'setAuthManually'
